import { useTranslation } from 'react-i18next';

interface AiBerichtZinProps {
  van: string;
  /** Absent in the team view: a colleague's melding takes no messages from this person. */
  onSpreekMens?: () => void;
  bezig?: boolean;
}

/**
 * AI Act art. 50(1): every AI message in "Mijn meldingen" says it comes from an AI
 * assistant, with a direct way to a human (spec P7). Renders nothing for other senders.
 */
export function AiBerichtZin({ van, onSpreekMens, bezig = false }: AiBerichtZinProps) {
  const { t } = useTranslation();
  if (van !== 'ai') return null;
  return (
    <p className="mt-1 flex flex-wrap items-center gap-sm text-[11.5px] text-text-muted">
      <span>{t('melden.ai')}</span>
      {onSpreekMens && (
        <button
          type="button"
          onClick={onSpreekMens}
          disabled={bezig}
          className="underline underline-offset-2 text-accent hover:text-accent-hover disabled:opacity-50"
        >
          {t('melden.mens')}
        </button>
      )}
    </p>
  );
}
